export const WINE_COLUMNS = ["Verre 16 cl", "Carafe 50 cl", "Bouteille 75 cl"];

export const CARTE_CATEGORIES = [
  { id: "entrees", title: "Entrées", sub: "Antipasti" },
  { id: "partager", title: "Entrées à partager", sub: "Da condividere" },
  { id: "pates", title: "Pâtes", sub: "Pasta" },
  { id: "plats", title: "Plats", sub: "Secondi" },
  { id: "pizzas", title: "Pizzeria", sub: "Pizza" },
  { id: "desserts", title: "Desserts", sub: "Dolci" },
  { id: "aperitifs", title: "Apéritifs", sub: "Aperitivi" },
  { id: "cocktails", title: "Cocktails" },
  { id: "virgin", title: "Virgin Cocktails", sub: "Sans alcool" },
  { id: "bieres-pression", title: "Bières Pression", sub: "Birre alla spina" },
  { id: "bieres-bouteille", title: "Bières Bouteille", sub: "Birre in bottiglia" },
  { id: "boissons", title: "Boissons Fraîches", sub: "Bibite" },
  { id: "cafeteria", title: "Caféterie", sub: "Caffetteria" },
  { id: "digestifs", title: "Digestifs", sub: "Digestivi" },
  { id: "whisky", title: "Whisky" },
  { id: "rhum", title: "Rhum" },
  { id: "vins-rouges", title: "Vins Rouges", sub: "Vino Rosso", columns: WINE_COLUMNS },
  { id: "prestige", title: "Sélection de Prestige", sub: "Selezione di Prestigio" },
  { id: "vins-blancs", title: "Vins Blancs", sub: "Vino Bianco", columns: WINE_COLUMNS },
  { id: "vins-roses", title: "Vins Rosés", sub: "Vino Rosato", columns: WINE_COLUMNS },
  { id: "bulles", title: "Les Bulles", sub: "Le Bollicine · Bouteille 75 cl" },
];

export const formatPrice = (item) => {
  if (item.price_text) return item.price_text;
  const n = Number(item.price || 0);
  return `${Number.isInteger(n) ? n : n.toFixed(2).replace(".", ",")} €`;
};

export const buildSections = (items) => {
  const known = CARTE_CATEGORIES.map((c) => c.title);
  const extra = [...new Set(items.map((i) => i.category))].filter((c) => !known.includes(c));
  const metas = [...CARTE_CATEGORIES, ...extra.map((c) => ({ id: c.toLowerCase().replace(/[^a-z0-9]+/g, "-"), title: c }))];
  return metas
    .map((meta) => {
      const rows = items.filter((i) => i.category === meta.title).map((i) => ({
        ...i,
        desc: i.description,
        price: formatPrice(i),
        prices: meta.columns && i.price_text ? i.price_text.split("|").map((p) => p.trim()) : null,
      }));
      if (!rows.length) return null;
      const labels = [...new Set(rows.map((r) => r.group).filter(Boolean))];
      const groups = labels.length ? labels.map((label) => ({ label, items: rows.filter((r) => r.group === label) })) : null;
      return { ...meta, items: rows, groups };
    })
    .filter(Boolean);
};
